// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-link {
  margin: 6px;
  border-radius: 8px;
  color: #c0c0c0;
  border: 1px solid #c0c0c0;
}

.category-div {
  width: 223px;
  color: black;
 
  padding: 4px 4px;
  font-weight: 600;
  font-size: 12px;
 
}

.category-input {
  padding: 6px;
  width: 100%;
  border-radius: 4px;
  /* border: 1px solid rgb(0, 119, 255); */
  border: none;
  outline: none;
  /* text-indent: 0.25rem; */
  /* background-color:grey; */
  background-color:#f8f9fa;
  color:black;
  font-size: 1rem;
}


.editmain .btn-primary {
  width: 200px;
  margin: auto;
  border:2px solid black !important;
background-color:rgb(237, 236, 236);
  color:black;
}

.edit-status-dropdown-div {
  
  background-color:white;
  color:black;
  justify-content: center;
  align-items: center;
  border:2px solid balck;
  border-radius: 5px;

  padding: 4px 4px;
  font-weight: 600;
  font-size: 12px;
  /* border: 1px solid rgb(58, 58, 58); */
}

.footerbttns {
  margin: auto;
  display: flex;
  align-content: center;
  justify-content: center;
  gap: 42px;
}

.editmain {
  display: flex;
  justify-content: center;
  flex-direction: row;
  justify-content: center;
  gap: 35px;
}

.addmain{


  display: flex;
  justify-content: center;
  flex-direction: row;
  justify-content: center;
  gap: 35px;


}

.delbttn{
background-color: #007449;

}

.addmain .btn {
  width: 200px;
  margin: auto;
  background-color: white;
  color: black;
}

.addmain .btn-primary {
  width: 200px;
  margin: auto;
  border:2px solid black !important;
background-color:rgb(237, 236, 236);
  color:black;
}

.savebttn {
  background-color: #007449;
}
.cancelbttn {
  background-color: rgb(186, 12, 12);
}

.addbttn{
  background-color: #007449;
}

.addbttn:hover {
  background-color: #084f34;
}

.categoriestable{
  border-radius: 4px;
}

.savebttn:hover {
  background-color: #084f34;
}

.cancelbttn:hover {
  background-color: rgb(106, 4, 4);
}

.additem{
  background-color: #007449;
}
.additem:hover{
  background-color: #0b4a34;
}

.addbutton{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

.addbuttontext{
  font-size:18px;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
}

.active > .page-link {
  background-color: #1b2f48;
  color: white;
  font-size: 14px;
  border: 1px solid #1b2f48;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
}

.page-item:not(:first-child) .page-link {
  margin-left: 0;
}

.table {
  font-size: 14px;
  /* border-radius: 20px; */
  margin: 24px 0;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.15);
}

.table-page {
  display: flex;
}

.react-bootstrap-table {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
}

.react-bootstrap-table th {
  background-color: #1b2f48;
  font-weight: 500;
}

.table thead th {
  color: white;
  text-align: center;
  background-color: #1b2f48;
  font-weight: 500;
}

/* Set border color for table rows */
.table tbody tr {
  border-color: #f6f6f6;
}

.table > thead {
  vertical-align: top;
  text-transform: capitalize;
}

.serial-number-header {
  width: 80px;
}

.serial-number-column {
  width: 80px;
}

.status-button-header {
  width: 180px;
}

.status-button-column {
  width: 180px;
}

.email-header {
  width: 150px;
}

.email-column {
  text-transform: lowercase !important;
}

.project-status-button-header {
  width: 200px;
}

.project-status-button-column {
  width: 200px;
}

tr {
  /* text-align: center; */
  border-color: #f6f6f6;
  border-style: solid;
  border-width: 1px;
}

.details td {
  vertical-align: middle;
  text-align: center;
  font-size: 14px;
  padding: 10px 20px;
}

label {
  margin: 5px 0;
  display: block;
}

label .form-control {
  display: inline-block;
  font-size: 10px;
}

.table-bordered > :not(caption) > * > * {
  border-width: 0;
}

.table-bordered > :not(caption) > * {
  border-width: none;
}

.react-bootstrap-table .filter input::placeholder {
  color: transparent;
}

.table > :not(caption) > * > * {
  padding: 1rem 0.5rem;
}

.projectbtn {
  display: flex;
  justify-content: space-between;
}

.Project-Button {
  width: 80%;
  background-color: #1b2f48;
  color: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  border: none;
}

.view-fish-button {
  padding: 8px;
  width: 50%;
  background-color: #1b2f48;
  color: white;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  border: none;
  margin-right: 14px;
}

.view-user-button {
  padding: 8px;
  width: 50%;
  border: 1px solid #1b2f48;
  color: #1b2f48;
  background-color: white;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 14px;
}

.Count-Button {
  vertical-align: middle;
  justify-content: center;
  align-items: center;
  display: flex;
  color: #1b2f48;
  background-color: white;
  border-radius: 50%;
  font-size: 14px;
  width: 36px;
  /* Adjust width */
  height: 36px;
  font-weight: 500;
  border: 1px solid #1b2f48;
}

.Count-Button.btn:hover {
  color: #1b2f48;
  background-color: white;
  border: 1px solid #1b2f48;
}

.entries-dropdown {
  display: flex;
  align-items: center;
}

.create-button {
  float: right;
  align-items: center;
  background-color: #082345;
  color: white;
  display: flex;
  padding: 6px 12px;
  font-size: 15px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
}

.create-button p {
  margin: 0;
  padding-bottom: 0;
  padding-left: 8px;
}

.create-button svg {
  font-size: 12px;
}

.custom-total {
  font-size: 15px;
  font-weight: 500;
}

.in-progress {
  /* color: #FF7A00; */
  background-color: yellow;
  color: white;
  text-transform: capitalize;
  font-weight: 500;
}

.cancelled {
  color: #00c2ff;
  text-transform: capitalize;
  font-weight: 500;
}

.completed {
  color: #2f9300;
  text-transform: capitalize;
  font-weight: 500;
}

.active-badge {
  background-color: #28a745;
  /* Green color for 'active' status */
}

.draft-badge {
  background-color: #ffc107;
  /* Yellow color for 'draft' status */
}

.projecttable-head {
  display: flex;
  width: 100%;
  flex-direction: column;
}

.projecttable-backarrow-div {
  display: flex;
  justify-content: space-between;
}

.user-card {
  display: flex;
}

.initial-letter {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 4rem;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  background-color: #1b2f48;
  color: #f6f6f6;
}

.first-letter img {
  width: 100px;
  height: 100px;
}

.user-details {
  margin-left: 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.user-details p {
  color: #6e6e6e;
  font-weight: 500;
}

.show-entries {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2rem;
}

.show-entries select {
  margin-left: 10px;
  padding: 2px 6px;
  border-radius: 5px;
  background-color: #f6f6f6;
  border: none;
  font-size: 14px;
}

.show-entries .form-control {
  float: right;
  width: 100%;
  font-size: 14px;
}

.pagination-div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.entries {
  color: black;
  font-size: 16px;
  font-weight: 500;
}

.pagination {
  display: flex;
  justify-content: end;
  align-items: center;
  cursor: pointer;
}

.pagination button {
  margin: 0 5px;
}

.pagination-button.active {
  color: white;
  background-color: #1b2f48;
  border: 1px solid #1b2f48;
  padding: 2px 10px;
}

.pagination-button {
  background-color: white;
  color: #c0c0c0;
  border: 1px solid #c0c0c0;
  padding: 2px 10px;
}

.pagination p {
  color: #939393;
  font-size: 16px;
  font-weight: 500;
  margin: 0 5px;
}

.sr-only {
  display: none;
}

.count {
  display: flex;
  justify-content: center;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
}

.pagination-controls {
  flex-grow: 1;
}

.pagination-and-entries {
  margin-left: 10px;
  /* Adjust as needed */
}

.export-button {
  color: white;
  background-color: #253f42;
  border: 1px solid #1b2f48;
  padding: 2px 10px;
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  margin-top: 4rem;
}

.details h3 {
  color: #253f42;
  font-weight: 700;
}

.details h3 span {
  font-weight: 600;
  color: #1b2f48;
  text-transform: capitalize;
}

.details p {
  font-size: 18px;
  font-weight: 600;
}

.details p span {
  font-size: 14px;
  font-weight: 500;
}

.description-header {
  width: 200px;
}

.description-column {
  width: 200px;
}

.status-pending-column {
  color: red;
}

.approve-button {
  color: black;
  background-color: white;
  border: 1px solid #1b2f48;
  padding: 8px;
  width: 100%;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  margin-top: 8px;
}

.report-icon {
  font-size: 24px;
}

.report-checkbox-main {
  column-gap: 10px;
  align-items: center;
  display: flex;
}

.business-modal img {
  margin: 4px;
  width: 150px;
  height: 150px;
  /* transition: transform 0.3s ease-in-out; */
}

.table thead th {
  width: 150px !important;
}

button#dropdown-basic {
  font-weight: 600;
  font-size: 14px;
  padding: 4px 8px;
}

.business-modal .modal-body {
  max-height: 450px; /* Adjust height as needed */
  overflow-y: auto;
}
.modal-body::-webkit-scrollbar {
  display: none;
}
.card-body {
  border-radius: 18px;
}
.plan-modal .card-title {
  color: #6c6c6c;
  font-size: 18px;
  font-weight: 700;
}

.plan-price {
  font-size: 16px;
  font-family: "Urbanist", serif;
  font-weight: 700;
  margin-bottom: 10px;
}

.plan-description {
  font-weight: 600;
  padding: 5px;
  height: 88px;
  background-color: #f2f2f2;
  font-family: "Urbanist", serif;
  font-size: 12px;
}

.pdf-svg {
  font-size: 34px;
  color: rgb(151, 28, 28);
}

.file-name {
  font-size: 16px;
  font-weight: 600;
  font-family: "Urbanist", serif;
}

.edit-button {
  padding: 8px 0;
  width: 50%;
  margin: 0 5px;
  background-color: white;
  color: #007449;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #007449;
}
.edit-button:hover {
  background-color: #007449;
  color: white;
  border: 1px solid #007449;
}
.edit-button-lg {
  padding: 8px 20px;
  width: 100%;
  /* margin: 0 5px; */
  background-color: white;
  color: #007449;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #007449;
  margin-right: 14px;
}
.edit-button-lg:hover {
  background-color: #007449;
  color: white;
  border: 1px solid #007449;
}
.view-button {
  padding: 8px;
  width: 7rem;
  /* margin: 0 5px; */
  background-color: white;
  color: #353e4c;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #353e4c;
  /* margin-right: 14px; */
}

.view-details-button {
  width: 100%;
  padding: 5px;
  margin: 0 5px;
  color: white;
  background-color: #353e4c;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #353e4c;
}
.view-details-button-lg {
  width: 7rem;
  margin: 0;
  color: white;
  background-color: #353e4c;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #353e4c;
}

.delete-button {
  padding: 8px 0;
  width: 50%;
  margin: 0 5px;
  background-color: rgb(202, 0, 0);
  color: white;
  font-size: 14px;
  border: 1px solid rgb(202, 0, 0);
  font-weight: 600;
}

.delete-button-lg {
  padding: 8px 20px;
  width: 100%;
  /* margin: 0 5px; */
  background-color: rgb(202, 0, 0);
  color: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid rgb(202, 0, 0);
  margin-right: 14px;
}

.category-action {
  display: flex;
  justify-content: space-around;
  column-gap: 10px;
  font-weight: 600;
  font-size: 14px;
}
.category-action {
  display: flex;
  justify-content: space-around;
  column-gap: 10px;
  font-weight: 600;
  font-size: 14px;
}
.subcategory-button {
  width: 80px;
  background-color: white;
  color: rgb(0, 0, 170);
  font-size: 14px;
  border: 1px solid rgb(0, 0, 170);
  font-weight: 600;
  padding: 7px 0;
}

/* 0.0.1 build CSS classes*/

.content-center {
  display: flex;
  justify-items: center;
  align-items: center;
}

.modal-cancel-button {
  background-color: white;
  color: black;
  border: 1px solid black;
  width: 80px;
  font-size: 14px;
  font-weight: 600;
  margin: 0 2px;
}

.modal-cancel-button:hover {
  background-color: rgb(178, 42, 42);
  color: black;
  border: 1px solid black;
}

.categoryImageDiv {
  width: 150px;
  height: 150px;
  position: relative;
}

.categoryEditValuesDiv {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 5px;
  width: 100%;
}

.categoryImage {
  width: 100%;
  height: 100%;
}

/* Flexbox Utilities */
.flex {
  display: flex;
}

.inline-flex {
  display: inline-flex;
}

.flex-row {
  flex-direction: row;
}

.flex-col {
  flex-direction: column;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-between {
  justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
}

.align-center {
  align-items: center;
}

.align-start {
  align-items: flex-start;
}

.align-end {
  align-items: flex-end;
}

/* Spacing Utilities */
.m-0 {
  margin: 0;
}

.m-1 {
  margin: 0.25rem;
}

.m-2 {
  margin: 0.5rem;
}

.m-4 {
  margin: 1rem;
}

.mt-0 {
  margin-top: 0;
}

.mt-1 {
  margin-top: 0.25rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.p-0 {
  padding: 0;
}

.p-1 {
  padding: 0.25rem;
}

.p-2 {
  padding: 0.5rem;
}

/* Text Utilities */
.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.text-xl {
  font-size: 1.25rem;
}

.text-lg {
  font-size: 1.125rem;
}

.text-sm {
  font-size: 0.875rem;
}

.font-bold {
  font-weight: bold;
}

.font-medium {
  font-weight: 500;
}

.font-light {
  font-weight: 300;
}

.text-gray-500 {
  color: #6b7280;
}

.text-red-500 {
  color: #f87171;
}

/* Background Utilities */
.bg-white {
  background-color: white;
}

.bg-gray-100 {
  background-color: #f3f4f6;
}

.bg-blue-500 {
  background-color: #3b82f6;
}

.bg-green-500 {
  background-color: #10b981;
}

/* Border Utilities */
.border {
  border: 1px solid #d1d5db;
}

.border-0 {
  border: 0;
}

.border-t {
  border-top: 1px solid #d1d5db;
}

.border-b {
  border-bottom: 1px solid #d1d5db;
}

.rounded {
  border-radius: 0.25rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-full {
  border-radius: 9999px;
}

/* Width Utilities */
.w-full {
  width: 100%;
}

.w-auto {
  width: auto;
}

/* Height Utilities */
.h-full {
  height: 100%;
}

.h-auto {
  height: auto;
}

.h-16 {
  height: 4rem;
}

.h-32 {
  height: 8rem;
}

/* Display Utilities */
.hidden {
  display: none;
}

.block {
  display: block;
}

.inline-block {
  display: inline-block;
}

.inline {
  display: inline;
}

.flex {
  display: flex;
}

.grid {
  display: grid;
}

.inline-flex {
  display: inline-flex;
}

/* Positioning */
.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.fixed {
  position: fixed;
}

.top-0 {
  top: 0;
}

.left-0 {
  left: 0;
}

.right-0 {
  right: 0;
}

.bottom-0 {
  bottom: 0;
}

/* Z-Index Utilities */
.z-0 {
  z-index: 0;
}

.z-10 {
  z-index: 10;
}

.z-20 {
  z-index: 20;
}

.cursor-pointer {
  cursor: pointer;
}

.border-none {
  border: none;
}

.outline-none {
  outline: none;
}

/* Custom indentation classes */

.indent-1 {
  text-indent: 0.25rem;
}

.indent-2 {
  text-indent: 0.5rem;
}

.indent-3 {
  text-indent: 0.75rem;
}

.indent-4 {
  text-indent: 1rem;
}

.indent-5 {
  text-indent: 1.25rem;
}

.indent-6 {
  text-indent: 1.5rem;
}

.image-close-icon {
  position: absolute;
  top: 8px;
  right: 2px;
  border-radius: 50%;
  color: white;
  background-color: red;
  padding: 0px 5px;
}

.back-button{
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  font-weight: 800;
}
.back-button:hover{
  background-color: #e7e7e7;
}

/* Upload Image / Edit Image CSS*/

.upload-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 90%;
}

.upload-box {
  border-radius: 5px;
  width: 100%;
  height: 100%;
  border: 2px dotted #007bff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  text-align: center;
}

.faPlus-icon {
  font-size: 20px;
  color: #007bff;
}

.upload-text {
  font-size: 14px;
  color: #007bff;
  font-weight: 500;
}

.upload-box:hover {
  background-color: #f0f8ff;
  border-color: #0056b3;
}

.faPlus-icon-div {
  padding: 3px 6px;
  border-radius: 50%;
  border: 1px solid #007bff;
}

.status-badge {
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 20px;
}

.add-item-modal-open-btn{
  background-color: rgb(43, 136, 0);
  font-weight: 500;
  color: white;
  border: 1px solid #1d7c00;
}

.add-item-modal-open-btn:hover{
  background-color: #226b00;
  border: 1px solid #226b00;
}

.modal-add-btn{
  background-color: white;
  border: 1px solid blue;
  color: blue;
  width: 9.5em;
}
.modal-add-btn:hover{
  background-color: rgb(1, 86, 184);
  border: 1px solid blue;
  color: white;
}
.modal-edit-btn{
  color: #046900;
  border: 1px solid #046900;
  background-color: #ffffff;
  width: 9.5em;
}
.modal-edit-btn:hover{
  background-color: #046900;
  border: 1px solid #046900;
  color: white;
}
.modal-edit-btn:disabled{
  background-color: #4f974c;
  border: 1px solid #4f974c;
  color: white;
}
.modal-delete-btn{
  background-color: white;
  border: 1px solid red;
  color: red;
  width: 9.5em;
}
.modal-delete-btn:hover{
  background-color: rgb(206, 0, 0);
  border: 1px solid red;
  color: white;
}
.modal-cancel-btn{
  background-color: white;
  border: 1px solid black;
  color: black;
  width: 9.5em;
}
.modal-cancel-btn:hover{
  background-color: rgb(46, 46, 46);
  border: 1px solid black;
  color: white;
}

.user-crud-icon{
  cursor: pointer;
  padding: 3px 8px;
  border-radius: 50%;
  font-size: 20px;
}

.user-crud-icon:hover{
  background-color: #e7e7e7;
}


`, "",{"version":3,"sources":["webpack://./src/Components/Tables/Table.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;;EAEZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;;AAEjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,WAAW;EACX,eAAe;AACjB;;;AAGA;EACE,YAAY;EACZ,YAAY;EACZ,iCAAiC;AACnC,mCAAmC;EACjC,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;;EAElB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;;;AAGX;;AAEA;AACA,yBAAyB;;AAEzB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iCAAiC;AACnC,mCAAmC;EACjC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,6EAA6E;AAC/E;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,sEAAsE;AACxE;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB,EAAE,4BAA4B;EAC/C,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,aAAa;EACb,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2BAA2B;;AAE3B;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA,+BAA+B;;AAE/B;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,UAAU;EACV,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".page-link {\n  margin: 6px;\n  border-radius: 8px;\n  color: #c0c0c0;\n  border: 1px solid #c0c0c0;\n}\n\n.category-div {\n  width: 223px;\n  color: black;\n \n  padding: 4px 4px;\n  font-weight: 600;\n  font-size: 12px;\n \n}\n\n.category-input {\n  padding: 6px;\n  width: 100%;\n  border-radius: 4px;\n  /* border: 1px solid rgb(0, 119, 255); */\n  border: none;\n  outline: none;\n  /* text-indent: 0.25rem; */\n  /* background-color:grey; */\n  background-color:#f8f9fa;\n  color:black;\n  font-size: 1rem;\n}\n\n\n.editmain .btn-primary {\n  width: 200px;\n  margin: auto;\n  border:2px solid black !important;\nbackground-color:rgb(237, 236, 236);\n  color:black;\n}\n\n.edit-status-dropdown-div {\n  \n  background-color:white;\n  color:black;\n  justify-content: center;\n  align-items: center;\n  border:2px solid balck;\n  border-radius: 5px;\n\n  padding: 4px 4px;\n  font-weight: 600;\n  font-size: 12px;\n  /* border: 1px solid rgb(58, 58, 58); */\n}\n\n.footerbttns {\n  margin: auto;\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  gap: 42px;\n}\n\n.editmain {\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  justify-content: center;\n  gap: 35px;\n}\n\n.addmain{\n\n\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  justify-content: center;\n  gap: 35px;\n\n\n}\n\n.delbttn{\nbackground-color: #007449;\n\n}\n\n.addmain .btn {\n  width: 200px;\n  margin: auto;\n  background-color: white;\n  color: black;\n}\n\n.addmain .btn-primary {\n  width: 200px;\n  margin: auto;\n  border:2px solid black !important;\nbackground-color:rgb(237, 236, 236);\n  color:black;\n}\n\n.savebttn {\n  background-color: #007449;\n}\n.cancelbttn {\n  background-color: rgb(186, 12, 12);\n}\n\n.addbttn{\n  background-color: #007449;\n}\n\n.addbttn:hover {\n  background-color: #084f34;\n}\n\n.categoriestable{\n  border-radius: 4px;\n}\n\n.savebttn:hover {\n  background-color: #084f34;\n}\n\n.cancelbttn:hover {\n  background-color: rgb(106, 4, 4);\n}\n\n.additem{\n  background-color: #007449;\n}\n.additem:hover{\n  background-color: #0b4a34;\n}\n\n.addbutton{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n}\n\n.addbuttontext{\n  font-size:18px;\n  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n}\n\n.active > .page-link {\n  background-color: #1b2f48;\n  color: white;\n  font-size: 14px;\n  border: 1px solid #1b2f48;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: 0;\n}\n\n.table {\n  font-size: 14px;\n  /* border-radius: 20px; */\n  margin: 24px 0;\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.15);\n}\n\n.table-page {\n  display: flex;\n}\n\n.react-bootstrap-table {\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.react-bootstrap-table th {\n  background-color: #1b2f48;\n  font-weight: 500;\n}\n\n.table thead th {\n  color: white;\n  text-align: center;\n  background-color: #1b2f48;\n  font-weight: 500;\n}\n\n/* Set border color for table rows */\n.table tbody tr {\n  border-color: #f6f6f6;\n}\n\n.table > thead {\n  vertical-align: top;\n  text-transform: capitalize;\n}\n\n.serial-number-header {\n  width: 80px;\n}\n\n.serial-number-column {\n  width: 80px;\n}\n\n.status-button-header {\n  width: 180px;\n}\n\n.status-button-column {\n  width: 180px;\n}\n\n.email-header {\n  width: 150px;\n}\n\n.email-column {\n  text-transform: lowercase !important;\n}\n\n.project-status-button-header {\n  width: 200px;\n}\n\n.project-status-button-column {\n  width: 200px;\n}\n\ntr {\n  /* text-align: center; */\n  border-color: #f6f6f6;\n  border-style: solid;\n  border-width: 1px;\n}\n\n.details td {\n  vertical-align: middle;\n  text-align: center;\n  font-size: 14px;\n  padding: 10px 20px;\n}\n\nlabel {\n  margin: 5px 0;\n  display: block;\n}\n\nlabel .form-control {\n  display: inline-block;\n  font-size: 10px;\n}\n\n.table-bordered > :not(caption) > * > * {\n  border-width: 0;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: none;\n}\n\n.react-bootstrap-table .filter input::placeholder {\n  color: transparent;\n}\n\n.table > :not(caption) > * > * {\n  padding: 1rem 0.5rem;\n}\n\n.projectbtn {\n  display: flex;\n  justify-content: space-between;\n}\n\n.Project-Button {\n  width: 80%;\n  background-color: #1b2f48;\n  color: white;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  border: none;\n}\n\n.view-fish-button {\n  padding: 8px;\n  width: 50%;\n  background-color: #1b2f48;\n  color: white;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  border: none;\n  margin-right: 14px;\n}\n\n.view-user-button {\n  padding: 8px;\n  width: 50%;\n  border: 1px solid #1b2f48;\n  color: #1b2f48;\n  background-color: white;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  margin-right: 14px;\n}\n\n.Count-Button {\n  vertical-align: middle;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  color: #1b2f48;\n  background-color: white;\n  border-radius: 50%;\n  font-size: 14px;\n  width: 36px;\n  /* Adjust width */\n  height: 36px;\n  font-weight: 500;\n  border: 1px solid #1b2f48;\n}\n\n.Count-Button.btn:hover {\n  color: #1b2f48;\n  background-color: white;\n  border: 1px solid #1b2f48;\n}\n\n.entries-dropdown {\n  display: flex;\n  align-items: center;\n}\n\n.create-button {\n  float: right;\n  align-items: center;\n  background-color: #082345;\n  color: white;\n  display: flex;\n  padding: 6px 12px;\n  font-size: 15px;\n  font-weight: 500;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.create-button p {\n  margin: 0;\n  padding-bottom: 0;\n  padding-left: 8px;\n}\n\n.create-button svg {\n  font-size: 12px;\n}\n\n.custom-total {\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.in-progress {\n  /* color: #FF7A00; */\n  background-color: yellow;\n  color: white;\n  text-transform: capitalize;\n  font-weight: 500;\n}\n\n.cancelled {\n  color: #00c2ff;\n  text-transform: capitalize;\n  font-weight: 500;\n}\n\n.completed {\n  color: #2f9300;\n  text-transform: capitalize;\n  font-weight: 500;\n}\n\n.active-badge {\n  background-color: #28a745;\n  /* Green color for 'active' status */\n}\n\n.draft-badge {\n  background-color: #ffc107;\n  /* Yellow color for 'draft' status */\n}\n\n.projecttable-head {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n}\n\n.projecttable-backarrow-div {\n  display: flex;\n  justify-content: space-between;\n}\n\n.user-card {\n  display: flex;\n}\n\n.initial-letter {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 4rem;\n  width: 100px;\n  height: 100px;\n  border-radius: 8px;\n  background-color: #1b2f48;\n  color: #f6f6f6;\n}\n\n.first-letter img {\n  width: 100px;\n  height: 100px;\n}\n\n.user-details {\n  margin-left: 20px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.user-details p {\n  color: #6e6e6e;\n  font-weight: 500;\n}\n\n.show-entries {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 2rem;\n}\n\n.show-entries select {\n  margin-left: 10px;\n  padding: 2px 6px;\n  border-radius: 5px;\n  background-color: #f6f6f6;\n  border: none;\n  font-size: 14px;\n}\n\n.show-entries .form-control {\n  float: right;\n  width: 100%;\n  font-size: 14px;\n}\n\n.pagination-div {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.entries {\n  color: black;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.pagination {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  cursor: pointer;\n}\n\n.pagination button {\n  margin: 0 5px;\n}\n\n.pagination-button.active {\n  color: white;\n  background-color: #1b2f48;\n  border: 1px solid #1b2f48;\n  padding: 2px 10px;\n}\n\n.pagination-button {\n  background-color: white;\n  color: #c0c0c0;\n  border: 1px solid #c0c0c0;\n  padding: 2px 10px;\n}\n\n.pagination p {\n  color: #939393;\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0 5px;\n}\n\n.sr-only {\n  display: none;\n}\n\n.count {\n  display: flex;\n  justify-content: center;\n}\n\n.pagination-wrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.pagination-controls {\n  flex-grow: 1;\n}\n\n.pagination-and-entries {\n  margin-left: 10px;\n  /* Adjust as needed */\n}\n\n.export-button {\n  color: white;\n  background-color: #253f42;\n  border: 1px solid #1b2f48;\n  padding: 2px 10px;\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.loading-spinner {\n  display: flex;\n  justify-content: center;\n  margin-top: 4rem;\n}\n\n.details h3 {\n  color: #253f42;\n  font-weight: 700;\n}\n\n.details h3 span {\n  font-weight: 600;\n  color: #1b2f48;\n  text-transform: capitalize;\n}\n\n.details p {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.details p span {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.description-header {\n  width: 200px;\n}\n\n.description-column {\n  width: 200px;\n}\n\n.status-pending-column {\n  color: red;\n}\n\n.approve-button {\n  color: black;\n  background-color: white;\n  border: 1px solid #1b2f48;\n  padding: 8px;\n  width: 100%;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  margin-top: 8px;\n}\n\n.report-icon {\n  font-size: 24px;\n}\n\n.report-checkbox-main {\n  column-gap: 10px;\n  align-items: center;\n  display: flex;\n}\n\n.business-modal img {\n  margin: 4px;\n  width: 150px;\n  height: 150px;\n  /* transition: transform 0.3s ease-in-out; */\n}\n\n.table thead th {\n  width: 150px !important;\n}\n\nbutton#dropdown-basic {\n  font-weight: 600;\n  font-size: 14px;\n  padding: 4px 8px;\n}\n\n.business-modal .modal-body {\n  max-height: 450px; /* Adjust height as needed */\n  overflow-y: auto;\n}\n.modal-body::-webkit-scrollbar {\n  display: none;\n}\n.card-body {\n  border-radius: 18px;\n}\n.plan-modal .card-title {\n  color: #6c6c6c;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.plan-price {\n  font-size: 16px;\n  font-family: \"Urbanist\", serif;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n.plan-description {\n  font-weight: 600;\n  padding: 5px;\n  height: 88px;\n  background-color: #f2f2f2;\n  font-family: \"Urbanist\", serif;\n  font-size: 12px;\n}\n\n.pdf-svg {\n  font-size: 34px;\n  color: rgb(151, 28, 28);\n}\n\n.file-name {\n  font-size: 16px;\n  font-weight: 600;\n  font-family: \"Urbanist\", serif;\n}\n\n.edit-button {\n  padding: 8px 0;\n  width: 50%;\n  margin: 0 5px;\n  background-color: white;\n  color: #007449;\n  font-size: 14px;\n  font-weight: 600;\n  border: 1px solid #007449;\n}\n.edit-button:hover {\n  background-color: #007449;\n  color: white;\n  border: 1px solid #007449;\n}\n.edit-button-lg {\n  padding: 8px 20px;\n  width: 100%;\n  /* margin: 0 5px; */\n  background-color: white;\n  color: #007449;\n  border-radius: 5px;\n  font-size: 14px;\n  font-weight: 600;\n  border: 1px solid #007449;\n  margin-right: 14px;\n}\n.edit-button-lg:hover {\n  background-color: #007449;\n  color: white;\n  border: 1px solid #007449;\n}\n.view-button {\n  padding: 8px;\n  width: 7rem;\n  /* margin: 0 5px; */\n  background-color: white;\n  color: #353e4c;\n  border-radius: 5px;\n  font-size: 14px;\n  font-weight: 600;\n  border: 1px solid #353e4c;\n  /* margin-right: 14px; */\n}\n\n.view-details-button {\n  width: 100%;\n  padding: 5px;\n  margin: 0 5px;\n  color: white;\n  background-color: #353e4c;\n  font-size: 14px;\n  font-weight: 600;\n  border: 1px solid #353e4c;\n}\n.view-details-button-lg {\n  width: 7rem;\n  margin: 0;\n  color: white;\n  background-color: #353e4c;\n  font-size: 14px;\n  font-weight: 600;\n  border: 1px solid #353e4c;\n}\n\n.delete-button {\n  padding: 8px 0;\n  width: 50%;\n  margin: 0 5px;\n  background-color: rgb(202, 0, 0);\n  color: white;\n  font-size: 14px;\n  border: 1px solid rgb(202, 0, 0);\n  font-weight: 600;\n}\n\n.delete-button-lg {\n  padding: 8px 20px;\n  width: 100%;\n  /* margin: 0 5px; */\n  background-color: rgb(202, 0, 0);\n  color: white;\n  border-radius: 5px;\n  font-size: 14px;\n  font-weight: 600;\n  border: 1px solid rgb(202, 0, 0);\n  margin-right: 14px;\n}\n\n.category-action {\n  display: flex;\n  justify-content: space-around;\n  column-gap: 10px;\n  font-weight: 600;\n  font-size: 14px;\n}\n.category-action {\n  display: flex;\n  justify-content: space-around;\n  column-gap: 10px;\n  font-weight: 600;\n  font-size: 14px;\n}\n.subcategory-button {\n  width: 80px;\n  background-color: white;\n  color: rgb(0, 0, 170);\n  font-size: 14px;\n  border: 1px solid rgb(0, 0, 170);\n  font-weight: 600;\n  padding: 7px 0;\n}\n\n/* 0.0.1 build CSS classes*/\n\n.content-center {\n  display: flex;\n  justify-items: center;\n  align-items: center;\n}\n\n.modal-cancel-button {\n  background-color: white;\n  color: black;\n  border: 1px solid black;\n  width: 80px;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 2px;\n}\n\n.modal-cancel-button:hover {\n  background-color: rgb(178, 42, 42);\n  color: black;\n  border: 1px solid black;\n}\n\n.categoryImageDiv {\n  width: 150px;\n  height: 150px;\n  position: relative;\n}\n\n.categoryEditValuesDiv {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 5px;\n  width: 100%;\n}\n\n.categoryImage {\n  width: 100%;\n  height: 100%;\n}\n\n/* Flexbox Utilities */\n.flex {\n  display: flex;\n}\n\n.inline-flex {\n  display: inline-flex;\n}\n\n.flex-row {\n  flex-direction: row;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-start {\n  justify-content: flex-start;\n}\n\n.justify-end {\n  justify-content: flex-end;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.justify-around {\n  justify-content: space-around;\n}\n\n.align-center {\n  align-items: center;\n}\n\n.align-start {\n  align-items: flex-start;\n}\n\n.align-end {\n  align-items: flex-end;\n}\n\n/* Spacing Utilities */\n.m-0 {\n  margin: 0;\n}\n\n.m-1 {\n  margin: 0.25rem;\n}\n\n.m-2 {\n  margin: 0.5rem;\n}\n\n.m-4 {\n  margin: 1rem;\n}\n\n.mt-0 {\n  margin-top: 0;\n}\n\n.mt-1 {\n  margin-top: 0.25rem;\n}\n\n.mt-2 {\n  margin-top: 0.5rem;\n}\n\n.mb-0 {\n  margin-bottom: 0;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem;\n}\n\n.p-0 {\n  padding: 0;\n}\n\n.p-1 {\n  padding: 0.25rem;\n}\n\n.p-2 {\n  padding: 0.5rem;\n}\n\n/* Text Utilities */\n.text-center {\n  text-align: center;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-xl {\n  font-size: 1.25rem;\n}\n\n.text-lg {\n  font-size: 1.125rem;\n}\n\n.text-sm {\n  font-size: 0.875rem;\n}\n\n.font-bold {\n  font-weight: bold;\n}\n\n.font-medium {\n  font-weight: 500;\n}\n\n.font-light {\n  font-weight: 300;\n}\n\n.text-gray-500 {\n  color: #6b7280;\n}\n\n.text-red-500 {\n  color: #f87171;\n}\n\n/* Background Utilities */\n.bg-white {\n  background-color: white;\n}\n\n.bg-gray-100 {\n  background-color: #f3f4f6;\n}\n\n.bg-blue-500 {\n  background-color: #3b82f6;\n}\n\n.bg-green-500 {\n  background-color: #10b981;\n}\n\n/* Border Utilities */\n.border {\n  border: 1px solid #d1d5db;\n}\n\n.border-0 {\n  border: 0;\n}\n\n.border-t {\n  border-top: 1px solid #d1d5db;\n}\n\n.border-b {\n  border-bottom: 1px solid #d1d5db;\n}\n\n.rounded {\n  border-radius: 0.25rem;\n}\n\n.rounded-lg {\n  border-radius: 0.5rem;\n}\n\n.rounded-full {\n  border-radius: 9999px;\n}\n\n/* Width Utilities */\n.w-full {\n  width: 100%;\n}\n\n.w-auto {\n  width: auto;\n}\n\n/* Height Utilities */\n.h-full {\n  height: 100%;\n}\n\n.h-auto {\n  height: auto;\n}\n\n.h-16 {\n  height: 4rem;\n}\n\n.h-32 {\n  height: 8rem;\n}\n\n/* Display Utilities */\n.hidden {\n  display: none;\n}\n\n.block {\n  display: block;\n}\n\n.inline-block {\n  display: inline-block;\n}\n\n.inline {\n  display: inline;\n}\n\n.flex {\n  display: flex;\n}\n\n.grid {\n  display: grid;\n}\n\n.inline-flex {\n  display: inline-flex;\n}\n\n/* Positioning */\n.relative {\n  position: relative;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.fixed {\n  position: fixed;\n}\n\n.top-0 {\n  top: 0;\n}\n\n.left-0 {\n  left: 0;\n}\n\n.right-0 {\n  right: 0;\n}\n\n.bottom-0 {\n  bottom: 0;\n}\n\n/* Z-Index Utilities */\n.z-0 {\n  z-index: 0;\n}\n\n.z-10 {\n  z-index: 10;\n}\n\n.z-20 {\n  z-index: 20;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.border-none {\n  border: none;\n}\n\n.outline-none {\n  outline: none;\n}\n\n/* Custom indentation classes */\n\n.indent-1 {\n  text-indent: 0.25rem;\n}\n\n.indent-2 {\n  text-indent: 0.5rem;\n}\n\n.indent-3 {\n  text-indent: 0.75rem;\n}\n\n.indent-4 {\n  text-indent: 1rem;\n}\n\n.indent-5 {\n  text-indent: 1.25rem;\n}\n\n.indent-6 {\n  text-indent: 1.5rem;\n}\n\n.image-close-icon {\n  position: absolute;\n  top: 8px;\n  right: 2px;\n  border-radius: 50%;\n  color: white;\n  background-color: red;\n  padding: 0px 5px;\n}\n\n.back-button{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 50%;\n  font-weight: 800;\n}\n.back-button:hover{\n  background-color: #e7e7e7;\n}\n\n/* Upload Image / Edit Image CSS*/\n\n.upload-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 90%;\n}\n\n.upload-box {\n  border-radius: 5px;\n  width: 100%;\n  height: 100%;\n  border: 2px dotted #007bff;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  text-align: center;\n}\n\n.faPlus-icon {\n  font-size: 20px;\n  color: #007bff;\n}\n\n.upload-text {\n  font-size: 14px;\n  color: #007bff;\n  font-weight: 500;\n}\n\n.upload-box:hover {\n  background-color: #f0f8ff;\n  border-color: #0056b3;\n}\n\n.faPlus-icon-div {\n  padding: 3px 6px;\n  border-radius: 50%;\n  border: 1px solid #007bff;\n}\n\n.status-badge {\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 20px;\n}\n\n.add-item-modal-open-btn{\n  background-color: rgb(43, 136, 0);\n  font-weight: 500;\n  color: white;\n  border: 1px solid #1d7c00;\n}\n\n.add-item-modal-open-btn:hover{\n  background-color: #226b00;\n  border: 1px solid #226b00;\n}\n\n.modal-add-btn{\n  background-color: white;\n  border: 1px solid blue;\n  color: blue;\n  width: 9.5em;\n}\n.modal-add-btn:hover{\n  background-color: rgb(1, 86, 184);\n  border: 1px solid blue;\n  color: white;\n}\n.modal-edit-btn{\n  color: #046900;\n  border: 1px solid #046900;\n  background-color: #ffffff;\n  width: 9.5em;\n}\n.modal-edit-btn:hover{\n  background-color: #046900;\n  border: 1px solid #046900;\n  color: white;\n}\n.modal-edit-btn:disabled{\n  background-color: #4f974c;\n  border: 1px solid #4f974c;\n  color: white;\n}\n.modal-delete-btn{\n  background-color: white;\n  border: 1px solid red;\n  color: red;\n  width: 9.5em;\n}\n.modal-delete-btn:hover{\n  background-color: rgb(206, 0, 0);\n  border: 1px solid red;\n  color: white;\n}\n.modal-cancel-btn{\n  background-color: white;\n  border: 1px solid black;\n  color: black;\n  width: 9.5em;\n}\n.modal-cancel-btn:hover{\n  background-color: rgb(46, 46, 46);\n  border: 1px solid black;\n  color: white;\n}\n\n.user-crud-icon{\n  cursor: pointer;\n  padding: 3px 8px;\n  border-radius: 50%;\n  font-size: 20px;\n}\n\n.user-crud-icon:hover{\n  background-color: #e7e7e7;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
